import { Reducer } from 'redux';

import {
  DashboardState,
  DeliveryNoteState,
  InboundInvoiceState,
  InboundTaskDocumentState,
  InboundTaskItemState,
  InventoryAdjustmentState,
  PickingTaskState,
  ReplenishTaskState,
  STOCheckBasketState,
  StockTransferState,
  STOPickItemState,
  STOReceiveItemState,
} from 'commons/types';
import { CompanyState } from 'commons/types/company.interface';
import { PackingTaskState } from 'commons/types/packingTask.interface';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';
import { UtilityState } from 'redux-stores/interfaces';

import companyInfoReducer from './companyInfoReducer';
import { dashboardReducer } from './dashboard.reducer';
import deliveryNoteReducer from './deliveryNoteReducer';
import inboundInvoiceReducer from './inboundInvoiceReducer';
import inboundTaskDocumentReducer from './inboundTaskDocumentReducer';
import inboundTaskItemReducer from './inboundTaskItemReducer';
import inventoryAdjustmentReducer from './inventoryAdjustment.reducer';
import packingTaskReducer from './packingTaskReducer';
import pickingTaskReducer from './pickingTaskReducer';
import { replenishTaskReducer } from './replenishTaskReducer';
import stoCheckBasketReducer from './stoCheckBasketReducer';
import { stockTransferReducer } from './stockTransfer.reducer';
import stoPickItemReducer from './stoPickItemReducer';
import stoReceiveItemReducer from './stoReceiveItemReducer';
import utilityReducer from './utilityReducer';

export interface RootReducerInterface extends Record<ReducerKeys, unknown> {
  [ReducerKeys.PickingTask]: PickingTaskState;
  [ReducerKeys.Utility]: UtilityState;
  [ReducerKeys.Dashboard]: DashboardState;
  [ReducerKeys.ReplenishTask]: ReplenishTaskState;
  [ReducerKeys.StockTransfer]: StockTransferState;
  [ReducerKeys.PackingTask]: PackingTaskState;
  [ReducerKeys.Company]: CompanyState;
  [ReducerKeys.InventoryAdjustment]: InventoryAdjustmentState;
  [ReducerKeys.STOPickItem]: STOPickItemState;
  [ReducerKeys.STOCheckBasket]: STOCheckBasketState;
  [ReducerKeys.STOReceiveItem]: STOReceiveItemState;
  [ReducerKeys.InboundTaskItem]: InboundTaskItemState;
  [ReducerKeys.InboundInvoice]: InboundInvoiceState;
  [ReducerKeys.InboundTaskDocument]: InboundTaskDocumentState;
  [ReducerKeys.DeliveryNote]: DeliveryNoteState;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer: Record<ReducerKeys, Reducer<any>> = {
  [ReducerKeys.ReplenishTask]: replenishTaskReducer,
  [ReducerKeys.PickingTask]: pickingTaskReducer,
  [ReducerKeys.Utility]: utilityReducer,
  [ReducerKeys.Dashboard]: dashboardReducer,
  [ReducerKeys.StockTransfer]: stockTransferReducer,
  [ReducerKeys.PackingTask]: packingTaskReducer,
  [ReducerKeys.Company]: companyInfoReducer,
  [ReducerKeys.InventoryAdjustment]: inventoryAdjustmentReducer,
  [ReducerKeys.STOPickItem]: stoPickItemReducer,
  [ReducerKeys.STOCheckBasket]: stoCheckBasketReducer,
  [ReducerKeys.STOReceiveItem]: stoReceiveItemReducer,
  [ReducerKeys.InboundTaskItem]: inboundTaskItemReducer,
  [ReducerKeys.InboundInvoice]: inboundInvoiceReducer,
  [ReducerKeys.InboundTaskDocument]: inboundTaskDocumentReducer,
  [ReducerKeys.DeliveryNote]: deliveryNoteReducer,
};

export default rootReducer;
